import { useId } from 'react';
import Input from './Input';

interface AutocompleteInputProps {
  value: string;
  options: string[];
  placeholder: string;
  onChange: (value: string) => void;
}

export default function AutocompleteInput({
  value,
  options,
  placeholder,
  onChange,
}: AutocompleteInputProps) {
  const listId = useId();

  return (
    <div className="w-full">
      <Input
        list={listId}
        value={value}
        placeholder={placeholder}
        autoComplete="off"
        onChange={(event) => onChange(event.target.value)}
      />
      <datalist id={listId}>
        {options.map((option) => (
          <option key={option} value={option} />
        ))}
      </datalist>
    </div>
  );
}
